var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 123 79.6"
    },
    viewBox: "0 0 123 79.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#264f26}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2_00000018204719803798221060000017562618969828766650_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3 44.5c.1 7.9-9.8 12.2-15.5 6.6-3.6-3.6-3.7-9.4-.1-13.1l.1-.1c5.7-5.6 15.5-1.3 15.5 6.6zm0 0c.1-7.7-9.6-11.6-14.9-6a8.7 8.7 0 0 0 0 12c5.2 5.6 14.9 1.7 14.9-6zM105.7 43.7c.1 7.9-9.8 12.2-15.5 6.6-3.6-3.6-3.7-9.4-.1-13.1l.1-.1c5.9-5.7 15.4-1.3 15.5 6.6zm0 0c-.1-7.7-9.6-11.6-14.9-6a8.7 8.7 0 0 0 0 12c5.3 5.6 15 1.7 14.9-6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7 36.7c-.3-8.8-.3-21.3-.4-30.2l.3-.1 17.3-3.2L105.2.1l.5-.1v.5c0 13.4-.2 26.8-.4 40.2-.3-13.4-.4-26.8-.5-40.2l.5.4c-8.6 1.6-25.9 4.8-34.5 6.3l.3-.4c0 8.9-.2 21.3-.4 29.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6 41.2c-.3-9.6-.4-19.1-.4-28.6 7.1-1.7 20.4-4.9 27.5-6.6 0 9.9-.1 19.7-.4 29.6-.3-9.7-.4-19.4-.4-29l.5.4c-6.6 1.6-19.9 4.8-26.6 6.3l.3-.4c-.1 9.5-.2 18.9-.5 28.3zM28 24.9c2.4 11.6 4.2 23.4 5.3 35.2-2.4-11.6-4.2-23.3-5.3-35.2z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2 66.3c-2.4-12.5-4.7-25.1-6.9-37.7 1.9.7 3.5 2 4.6 3.7 1 1.3 1.9 2.8 2.8 4.3l-.5-.3 2.8-.4-.4.5c-.9-7.4-6-12.5-13.7-11.5 8.2-1.8 13.8 4 14.7 11.9-.2 0-3 .5-3.3.5l-.3.1c-1.2-2.3-2.7-4.4-4.4-6.3-.5-.6-1.2-1-1.9-1.3l.6-.5c2 12.3 4 24.6 5.9 37z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6 68c.8 5.5-3 10.6-8.5 11.5s-10.6-3-11.5-8.5c-.4-2.7.3-5.4 2-7.6 3.4-4.4 9.8-5.2 14.2-1.8 2 1.5 3.4 3.8 3.8 6.4zm0 0c-.8-5.2-5.6-8.9-10.9-8.1-5.2.8-8.9 5.6-8.1 10.9.4 2.5 1.7 4.7 3.7 6.2 6.7 5.3 16.6-.5 15.3-9zM50.3 61.5c3 .3 5.9 1.2 8.5 2.8-2.9-.3-5.9-1.2-8.5-2.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 58.6c-.3 3-1.2 5.9-2.8 8.5.3-3 1.2-5.9 2.8-8.5zM6.2 44.1c3 .3 5.9 1.2 8.5 2.8-3-.2-5.9-1.2-8.5-2.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 41.3c-.3 3-1.2 5.9-2.8 8.5.3-3 1.3-5.9 2.8-8.5zM0 20.9c4.3.7 8.5 2 12.4 4-4.3-.7-8.5-2-12.4-4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 16.7c-.7 4.3-2 8.5-4 12.4.7-4.3 2-8.5 4-12.4zM110.3 64.9c3 .3 5.9 1.2 8.5 2.8-3-.3-5.9-1.2-8.5-2.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 62.1c-.3 3-1.2 5.9-2.8 8.5.3-3 1.2-6 2.8-8.5zM114.5 34.2c3 .3 5.9 1.2 8.5 2.8-3-.3-5.9-1.2-8.5-2.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1 31.4c-.3 3-1.2 5.9-2.8 8.5.3-3 1.3-6 2.8-8.5zM48.4 22.9c4.3.7 8.5 2.1 12.4 4.1-4.3-.7-8.5-2-12.4-4.1z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6 18.8c-.7 4.3-2 8.5-4 12.4.7-4.4 2.1-8.6 4-12.4z",
    className: "st0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.3c59b9685280c7c811106bac70acf419.svg";
export { ForwardRef as ReactComponent };